import formatByCountry from "./FormatByCountry";
import { MY_CURRENCY_DISPLAY_PREFIX } from "./modules/Price";

const formatPriceRM = (price: number): string => {
  return formatByCountry(price, {
    type: "money",
    country: "MY",
    prefix: MY_CURRENCY_DISPLAY_PREFIX
  });
};
export default formatPriceRM;
